module.exports = __webpack_public_path__ + "media/images/gallery/constellations/libra/lib_names-72e17aded705de40875fcfaa6e4d0fca.gif";